// project imports
import ErrorBoundary from 'components/ErrorBoundary';
import Loadable from 'components/Loadable';
import Tracker from 'components/Tracker';
import MainLayout from 'layouts/MainLayout';
import { lazy } from 'react';
// ==============================|| MAIN ROUTING ||============================== //
const LandingPage = Loadable(lazy(() => import('pages/LandingPage')));
const HomePage = Loadable(lazy(() => import('pages/HomePage')));
const AgreePage = Loadable(lazy(() => import('pages/AgreePage')));
const QuestionPage = Loadable(lazy(() => import('pages/QuestionPage')));
const DiscountPage = Loadable(lazy(() => import('pages/DiscountPage')));
const GiftPage = Loadable(lazy(() => import('pages/GiftPage')));
const TermsPage = Loadable(lazy(() => import('pages/TermsPage')));

const MainRoutes = [
    {
        path: '/',
        element: <MainLayout />,
        children: [
            {
                path: '',
                element: (
                    <Tracker ga="lading_page">
                        <LandingPage />
                    </Tracker>
                )
            },
            {
                path: '/home',
                element: (
                    <Tracker ga="page_home">
                        <HomePage />
                    </Tracker>
                )
            },
            {
                path: '/form',
                element: (
                    <ErrorBoundary>
                        <Tracker ga="page_consent_bound">
                            <AgreePage />
                        </Tracker>
                    </ErrorBoundary>
                )
            },
            {
                path: '/terms',
                element: <TermsPage />
            },
            {
                path: '/question',
                element: (
                    <Tracker ga="view_question">
                        <QuestionPage />
                    </Tracker>
                )
            }
        ]
    },
    {
        path: '/exchange',
        element: <MainLayout />,
        children: [
            {
                path: '',
                element: (
                    <Tracker ga="view_exchange_coupon">
                        <DiscountPage />
                    </Tracker>
                )
            },
            {
                path: 'gift',
                element: (
                    <Tracker ga="view_exchange_gift">
                        <GiftPage />
                    </Tracker>
                )
            }
        ]
    }
];

export default MainRoutes;
